// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getProductsApi } from "../../Service/Api/ProductListApi"
import { getProductList,getErrors } from "../Reducer/ProductListReducer"



// Watchers
function* productListSaga() {
	yield takeEvery("product_list/getProducts", getAllProducts)
}

// Sagas
function* getAllProducts(action) {
    // console.log(action)
	try {
        const getProducts = yield call(getProductsApi, action.payload)
        // console.log(getProducts,"ldfgsdgb")

		if (getProducts.request.status === 200) {
			yield put(getProductList(getProducts))
		} else {
			yield put(getErrors(true))
		}
	} catch (error) {
		// console.log(error,"otp error")
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(productListSaga)])
}
